import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function Cancel2Icon({
  className,
  style,
  color = "#050530",
  ...props
}: IconProps & { color?: string }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 21 20'
      fill='none'
      {...props}
    >
      <circle cx='10.4297' cy='10' r='9.5' fill='#F9FBFE' stroke={color} />
      <path
        d='M14.2758 6.15332L6.5835 13.8456'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.5835 6.15332L14.2758 13.8456'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
